/**
 * Component per copiar lots o emnp`lçaments d'eleccions anteriors
 * Component: CopyEleAnt.tsx
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 06/04/2020
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */

import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TableContainer, Radio } from '@material-ui/core';
import DataGrid from 'ajt-data-grid';
import DataGridField, { IDataGridField } from 'ajt-data-grid/lib/src/DataGridField';
import { IDataGridRowInfo } from 'ajt-data-grid/lib/src/DataGrid';
import AppState from '../states/AppState';
import { IEleccio } from '../interfaces/IEleccio';

interface IPropsCopyEleAnt {
    appState: AppState;
    onClose: () => void;
};

interface ILinia {
    eleCod: number;
    eleDesc: string;
    dataEle: string;
}

@observer
export default class CopyEleAnt extends React.Component<IPropsCopyEleAnt, {}> {
    constructor(props: IPropsCopyEleAnt) {
        super(props);
        this.getInfo();
    }

    /** Línies */
    @observable linies: Array<ILinia> = [];

    /** Elecció seleccionada */
    @observable selEle: number = 0;

    /**
     * Recuperem la el número de lots i fanals de cada categoria
     */
    @action async getInfo() {
        let lins: Array<ILinia> = [];
        let eles: Array<IEleccio> = [];
        if (this.props.appState.typeCopyEleAntDlg === 'L') {
            eles = this.props.appState.lotsAnt;
        } else if (this.props.appState.typeCopyEleAntDlg === 'E') {
            eles = this.props.appState.emplsAnt;
        }
        for (let i:number = 0; i < eles.length; i++){
            lins.push({eleCod: eles[i].eleCod, eleDesc: eles[i].eleDesc, dataEle: eles[i].dataEle});
        }
        this.linies = lins;
    }
    
    /** Posa el elcod de l'elecció seleccionada */
    @action setSelEle(eleCod: number) {
        this.selEle = eleCod;
        // console.log(eleCod);
    }

    // Tanca el diàleg
    private handleClose = (desar: boolean) => {
        // console.log(desar);
        // console.log(this.selEle);
        if (desar) {
            let ele: IEleccio = this.linies.find(el => el.eleCod = this.selEle);
            if (ele) {
                this.props.appState.dialState.messageBox({
                    title: 'Atenció!',
                    message: (<div>Amb aquesta acció {(this.props.appState.typeCopyEleAntDlg === 'L') ? 's\'eliminaran totes les seleccions i ordenacions de lots de fanals' : 's\'eliminarà l\'ordenació d\'emplaçaments'} que hagueu fet fins ara i es
                            {(this.props.appState.typeCopyEleAntDlg === 'L') ? ' substituiran per les' : ' substituirà per la'} que vàreu fer al procés electoral <b>{ele.eleDesc}</b> de <b>{ele.dataEle}</b>.<br />
                            Tingueu en compte que els {(this.props.appState.typeCopyEleAntDlg === 'L') ? 'fanals' : 'emplaçaments'} posats a disposició poden haver canviat i, per tant, la configuració resultant pot no ser exactament 
                            igual que la que vàreu fer en aquell moment.<br />
                            Us recomanem que repasseu el resultat un cop realitzada l'acció.<br /><br />
                            <b>¿Voleu continuar amb la importació?</b>
                    </div>),
                    buttons:[{ label: 'No', secondary: true, default: true }, { label: 'Sí', primary: true, default: false }]
                }).then(boto => {
                    if (boto === 'Sí') {
                        const callBack = this.props.appState.callBackEleAntDlg; 
                        if (this.props.appState.typeCopyEleAntDlg === 'L') {
                            this.props.appState.setLotsAnt(this.selEle).then(resultat => {
                                if (callBack) {
                                    callBack();
                                }
                            });
                        } else if (this.props.appState.typeCopyEleAntDlg === 'E') {
                            this.props.appState.setEmplsAnt(this.selEle).then(resultat => {
                                if (callBack) {
                                    callBack();
                                }
                            });
                        }
                        this.props.onClose();        
                    }
                });
            }
        } else {
            this.props.onClose();
        }
    }

    // Hwm triat una elecció
    private handleChangeEle = (eleCod: number) => {
        this.setSelEle(eleCod);
    }

    // Editem una línia
    private templateSelectRow = (value: {}, item?: {}, col?: IDataGridField<ILinia>, row?: IDataGridRowInfo) => (<Radio
        checked={this.selEle === this.linies[row.rowIndex].eleCod}
        onChange={this.handleChangeEle.bind(this, this.linies[row.rowIndex].eleCod)}
        value="a"
        name="radio-button-demo"
        inputProps={{ 'aria-label': this.linies[row.rowIndex].eleCod.toString() }}
      />)

    // Render !
    render(): JSX.Element {

        // Rederitzem
        return (<Dialog 
                open={!!this.props.appState.showCopyEleAntDlg}
                onClose={this.handleClose}
                maxWidth={'md'}
                fullWidth={true}
            >
                <DialogTitle id="form-dialog-title">{'Seleccionar el procés electoral del que voleu importar la selecció ' + (this.props.appState.typeCopyEleAntDlg === 'L' ? 'de lots' : 'd\'emplaçaments')}</DialogTitle>
                <DialogContent>
                    <TableContainer style={{maxHeight: '250px'}}>
                        <DataGrid
                            fixedHeader={true}
                            showRowHover={true}
                            dataSource={this.linies}
                            size="small"
                        >
                            <DataGridField field="" title=" " width={50} template={this.templateSelectRow} style={{textAlign: 'center'}} styleHeader={{textAlign: 'left'}}/>
                            {/* <DataGridField field="eleCod" title="CODI" width={100} style={{textAlign: 'left'}} styleHeader={{textAlign: 'left'}}/> */}
                            <DataGridField field="eleDesc" title="PROCÉS ELECTORAL" width={200} style={{textAlign: 'left'}} styleHeader={{textAlign: 'left'}}/>
                            <DataGridField field="dataEle" title="DATA" width={100} style={{textAlign: 'center'}} styleHeader={{textAlign: 'center'}}/>
                        </DataGrid>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose.bind(this, false)} color="secondary">Cancel·lar</Button>
                    <Button onClick={this.handleClose.bind(this, true)} color="primary" disabled = {this.selEle === 0}>Acceptar</Button>
                </DialogActions>
            </Dialog>);
    }
}
